var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 38,
    fill: "none",
    viewBox: "0 0 35 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.2708 17.9773C22.2966 17.9773 26.3708 14.0089 26.3708 9.11364C26.3708 4.21838 22.2966 0.25 17.2708 0.25C12.245 0.25 8.17078 4.21838 8.17078 9.11364C8.17078 14.0089 12.245 17.9773 17.2708 17.9773ZM8.44971 20.8506C3.78306 20.8506 0 24.6337 0 29.3003C0 33.9669 3.78307 37.75 8.44971 37.75H26.5503C31.2169 37.75 35 33.9669 35 29.3003C35 24.6337 31.2169 20.8506 26.5503 20.8506H8.44971Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceholder);
export default __webpack_public_path__ + "static/media/profile-placeholder.71d466b11c34d93abbe2a71e1d54f9e1.svg";
export { ForwardRef as ReactComponent };